import React, { useReducer } from 'react';
import { useSelector } from 'react-redux';

import { DISMISSED_PRICING_BANNER_VENUE_IDS_LOCAL_STORAGE_KEY } from 'constants/logic';
import { getKeyForUser, setKeyForUser } from 'helpers/local-storage';
import { useIsServicePricingProofEnabled } from 'hooks/useIsServicePricingProofEnabled';
import { selectActiveVenueId, selectDismissedPricingBannerVenueIds, selectUserId } from 'selectors/general';

import useVenuePricingActionRequired from '../../hooks/useVenuePricingActionRequired';
import PricingActionRequiredBanner from './PricingActionRequiredBanner';

const persistDismissal = (userId, venueId) => {
  const dismissed = new Set(getKeyForUser(userId, DISMISSED_PRICING_BANNER_VENUE_IDS_LOCAL_STORAGE_KEY, []));
  dismissed.add(venueId);
  setKeyForUser(userId, DISMISSED_PRICING_BANNER_VENUE_IDS_LOCAL_STORAGE_KEY, Array.from(dismissed));
};

const PricingActionRequiredBannerContainer = () => {
  // selectDismissedPricingBannerVenueIds reads localStorage uncached; bump this
  // after a dismissal write so the new value is picked up without a remount.
  const [, forceReadDismissals] = useReducer(count => count + 1, 0);

  const userId = useSelector(selectUserId);
  const venueId = useSelector(selectActiveVenueId);
  const dismissedVenueIds = useSelector(selectDismissedPricingBannerVenueIds);
  const isPricingProofEnabled = useIsServicePricingProofEnabled();

  const isAlreadyDismissed = dismissedVenueIds.includes(venueId);
  const { hasRejectedRequest } = useVenuePricingActionRequired(
    venueId,
    isPricingProofEnabled === true && !isAlreadyDismissed
  );

  if (!hasRejectedRequest || isAlreadyDismissed) {
    return null;
  }

  const handleDismiss = () => {
    persistDismissal(userId, venueId);
    forceReadDismissals();
  };

  return <PricingActionRequiredBanner onDismiss={handleDismiss} />;
};

export default PricingActionRequiredBannerContainer;
